<h2>Frequently Asked Questions</h2>
<mat-accordion [multi]="true">
  @for (faq of faqs; track faq) {
    <mat-expansion-panel>
      <mat-expansion-panel-header>
        <mat-panel-title>
          {{ faq.question }}
        </mat-panel-title>
      </mat-expansion-panel-header>
      <p>{{ faq.answer }}</p>
    </mat-expansion-panel>
  }
</mat-accordion>
